import { useCallback, useEffect, useRef, useState } from "react";
import { EllipsisHorizontalIcon, PencilIcon, TrashIcon } from "@heroicons/react/24/solid";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import classNames from "classnames";
import classes from "./classes.module.scss";

type IProps = {
	onEditClick: () => void;
	onDeleteClick: () => void;
	className?: string;
};

export default function ManageCardMenu(props: IProps) {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const menuRef = useRef<HTMLDivElement>(null);

	const toggleMenu = useCallback(() => setIsMenuOpen((prev) => !prev), []);
	const closeMenu = useCallback(() => setIsMenuOpen(false), []);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
				closeMenu();
			}
		};

		if (isMenuOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isMenuOpen, closeMenu]);

	return (
		<div className={classNames(classes["root"], props.className)} ref={menuRef}>
			<EllipsisHorizontalIcon className={classes["icon"]} onClick={toggleMenu} />

			{isMenuOpen && (
				<div className={classNames(classes["menu"], { [classes["open"]!]: isMenuOpen })}>
					<div className={classes["menu-item"]} onClick={props.onEditClick}>
						<PencilIcon className={classes["icon"]} />
						<Typography type="p" weight="medium">
							{I18n.trslt(I18n.asset.common.edit)}
						</Typography>
					</div>
					<div className={classes["menu-item"]} onClick={props.onDeleteClick}>
						<TrashIcon className={classes["icon"]} />
						<Typography type="p" weight="medium">
							{I18n.trslt(I18n.asset.common.delete)}
						</Typography>
					</div>
				</div>
			)}
		</div>
	);
}
